var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container"},[_c('div',{class:{
      'avatar': true,
      [`avatar-${_vm.rank}`]: true,
    }},[_c('img',{staticClass:"avatar-icon",attrs:{"src":_vm.current}}),_c('img',{staticClass:"avatar-img",attrs:{"src":_vm.src}})]),_c('div',{staticClass:"avatar-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }